import { SUPPORTED_LANGUAGES, DEFAULT_LANGUAGE } from '@/legacy/i18n/resources';

export function getLanguage(): string {
	const browserLanguage = navigator.language.split('-')[0] ?? DEFAULT_LANGUAGE;
	const resolvedBrowserLanguage = SUPPORTED_LANGUAGES.includes(browserLanguage)
		? browserLanguage
		: DEFAULT_LANGUAGE;
	try {
		const raw = localStorage.getItem('store');
		if (!raw) return resolvedBrowserLanguage;

		const parsed = JSON.parse(raw);
		const storedLanguage = parsed?.state?.languageAbbreviation;
		if (storedLanguage && SUPPORTED_LANGUAGES.includes(storedLanguage)) {
			return storedLanguage;
		}
		return resolvedBrowserLanguage;
	} catch {
		return resolvedBrowserLanguage;
	}
}

export const capitalizeFirstLetter = (str: string) => str.charAt(0).toUpperCase() + str.slice(1);
